import '../lib/readmore-fixed';

$(document).ready(function () {
  var more;
  var less;
  var more1;
  var less1;
  more = 'Lees meer';
  less = 'Lees minder';
  more1 = 'Bekijk alle kenmerken';
  less1 = 'Minder kenmerken';
  if($('.check-current-lang-en').length){
    more = 'Read more';
    less = 'Read less';
    more1 = 'View all features';
    less1 = 'Fewer features';
  }

  $('.rw-description__content.rw-description__content--big').readmore({
    embedCSS: true,
    moreLink:
      '<a href="#" class="btn btn-primary mt-4" alt="'+more+'" title="'+more+'">'+more+' <i class="icon icon-arrow-right"></i></a>',
    lessLink:
      '<a href="#" alt="'+less+'" title="'+less+'" class="btn btn-primary mt-4" onclick="window.scrollTo(\'.rw-description__content.rw-description__content--big\')">'+less+' <i class="icon icon-arrow-right"></i></a>',
    collapsedHeight: 400,
    beforeToggle: function () {
      $('.rw-description__content.rw-description__content--big').toggleClass(
        'active-readmore'
      );
    },
  });

  $('.rw-description__content:not(.rw-description__content--big)').readmore({
    embedCSS: true,
    moreLink:
      '<a href="#" alt="'+more+'" title="'+more+'" class="btn btn-primary mt-3" data-aos="fade-right">'+more+' <i class="icon icon-arrow-right"></i></a>',
    lessLink:
      '<a href="#" alt="'+less+'" title="'+less+'" class="btn btn-primary mt-4" onclick="window.scrollTo(\'.rw-description__content:not(.rw-description__content--big)\')">'+less+' <i class="icon icon-arrow-right"></i></a>',
    collapsedHeight: 203,
    beforeToggle: function () {
      $(
        '.rw-description__content:not(.rw-description__content--big)'
      ).toggleClass('active-readmore');
    },
  });

  $('.rw-description__features').readmore({
    embedCSS: true,
    moreLink:
      '<a href="#" alt="'+more1+'" title="'+more1+'" class="btn btn-primary mt-3" data-aos="fade-right">'+more1+' <i class="icon icon-arrow-right"></i></a>',
    lessLink:
      '<a href="#" alt="'+less1+'" title="'+less1+'" class="btn btn-primary mt-4" onclick="window.scrollTo(\'.rw-description__features\')">'+less1+' <i class="icon icon-arrow-right"></i></a>',
    collapsedHeight: 400,
    beforeToggle: function () {
      $('.rw-description__features').toggleClass('active-readmore');
    },
  });
});
